import { CmsMeta } from './cmsMeta';
import { useConfig } from '../../config';

export const CmsCustomerServicePhone = () => {
	const { customerServicePhoneNumber } = useConfig();
	return <>{customerServicePhoneNumber}</>;
};

export const cmsMeta: CmsMeta = {
	description:
		"The market's customer service phone number, resolved at render time. Always use this rather than typing the number, so it stays correct and identically formatted everywhere.",
	example: ['CmsCustomerServicePhone', {}],
};
